document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('lite-wistia[data-autoplay="true"]')
    .forEach(function (video) {
      //console.log(video); // Verify the element before calling the method
      video.addIframe();
    });
});

document
  .querySelectorAll(".main-menu, .main-menu-mobile")
  .forEach(function (menu) {
    menu.addEventListener("click", function () {
      closeSearch();
      adjustLogoOpacity();
      toggleMenu(".riester-main-menu-container", 0.3);
    });
  });

function toggleOpacity(selector, fadeOutDuration, fadeInDuration) {
  const element = document.querySelector(selector);
  let opacity = getComputedStyle(element).opacity;

  if (opacity > 0) {
    fadeElement(element, 0, fadeOutDuration); // Fade out
  } else {
    fadeElement(element, 1, fadeInDuration); // Fade in
  }
}

function adjustLogoOpacity() {
  const logoElements = [
    { selector: "#i", fadeOut: 0.6, fadeIn: 0.1 },
    { selector: "#e", fadeOut: 0.5, fadeIn: 0.2 },
    { selector: "#s", fadeOut: 0.4, fadeIn: 0.3 },
    { selector: "#t", fadeOut: 0.3, fadeIn: 0.4 },
    { selector: "#e-last", fadeOut: 0.2, fadeIn: 0.5 },
    { selector: "#r-last", fadeOut: 0.1, fadeIn: 0.6 },
  ];

  logoElements.forEach((element) => {
    toggleOpacity(element.selector, element.fadeOut, element.fadeIn);
  });

  document.querySelector(".logo").classList.toggle("shrink");
}

function fadeElement(element, targetOpacity, duration) {
  let start = null;
  const initialOpacity = parseFloat(getComputedStyle(element).opacity);
  const delta = targetOpacity - initialOpacity;

  function step(timestamp) {
    if (!start) start = timestamp;
    const progress = (timestamp - start) / (duration * 1000);
    const newOpacity = initialOpacity + progress * delta;
    element.style.opacity = newOpacity;

    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      element.style.opacity = targetOpacity; // Ensure final opacity is set
    }
  }

  window.requestAnimationFrame(step);
}
function toggleMenu(selector) {
  const menu = document.querySelector(selector);
  menu.classList.toggle("open");
  updateLogoClass(); // Existing call
  document.body.classList.toggle("menu-open", menu.classList.contains("open")); // Toggle 'menu-open' class on body
}

function toggleSearch(selector) {
  const searchContainer = document.querySelector(selector);
  searchContainer.classList.toggle("open");
  updateLogoClass(); // Existing call
  document.body.classList.toggle(
    "menu-open",
    searchContainer.classList.contains("open")
  ); // Toggle 'menu-open' class on body
}

function closeMenu() {
  const menu = document.querySelector(".riester-main-menu-container");
  if (menu.classList.contains("open")) {
    menu.classList.remove("open");
    document.body.classList.remove("menu-open"); // Remove 'menu-open' class from body
  }
}

function closeSearch() {
  const searchContainer = document.querySelector(".riester-search-container");
  if (searchContainer.classList.contains("open")) {
    searchContainer.classList.remove("open");
    document.body.classList.remove("menu-open"); // Remove 'menu-open' class from body
  }
}

const menuButton = document.querySelector("button.main-menu");
const plusMinus = menuButton.querySelector("svg.nav-plus");

menuButton.addEventListener("click", togglePlusMinus);

function togglePlusMinus() {
  plusMinus.classList.toggle("minus");
}

function updateLogoClass() {
  const mainMenuContainer = document.querySelector(
    ".riester-main-menu-container"
  );
  const menuContainer = document.querySelector(".menu-main-menu-container");
  const logo = document.querySelector("a.logo");

  // Check if either container has the 'open' class and logo already has 'shrink'
  if (
    logo.classList.contains("shrink") &&
    (mainMenuContainer.classList.contains("open") ||
      menuContainer.classList.contains("open"))
  ) {
    // Keep the shrink class
  } else {
    //console.log("Conditions not met, do not add or remove shrink");// Conditions not met, do not add or remove 'shrink'
  }
}

document.querySelector("button.search").addEventListener("click", function () {
  closeMenu();
  adjustLogoOpacity();
  toggleSearch(".riester-search-container", 0.4);
});

document.addEventListener("DOMContentLoaded", function () {
  updateLogoClass();

  // Adding event listeners to all links in the main menu
  document
    .querySelectorAll(".riester-main-menu-container a")
    .forEach(function (link) {
      link.addEventListener("click", function () {
        closeMenu(); // Call closeMenu function when a link is clicked
      });
    });

  // Check if the cookie is set and update the theme
  var theme = getCookie("theme");
  if (theme === "darkmode") {
    document.body.classList.add("darkmode");
  }

  // Add event listener to your theme switcher button
  var themeSwitchers = document.querySelectorAll("[data-theme-toggle]");
themeSwitchers.forEach(function (themeSwitcher) {
  themeSwitcher.addEventListener("click", function () {
    document.body.classList.toggle("darkmode");
    var newTheme = document.body.classList.contains("darkmode")
      ? "darkmode"
      : "lightmode";
    setCookie("theme", newTheme, 36);

    // Update all weather icons to reflect the current theme mode
    updateAllWeatherIcons(); // Ensure this function calls updateWeatherInfo for each location
  });
});
});

function setCookie(name, value, hours) {
  var expires = "";
  if (hours) {
    var date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/*
let resizeTimer;
window.onresize = function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        calculate_row_height();
        adjustFirstContentSlideHeight(); // Assuming this function is defined to adjust the first content slide specifically
    }, 250); // Adjust delay as needed
};
*/

class LiteWistiaEmbed extends HTMLElement {
  connectedCallback() {
    this.videoId = this.getAttribute("videoid");
   
    if (this.getAttribute("data-autoplay") !== "true") {
      this.setupPlayButton();
    }
    this.addEventListener("pointerover", LiteWistiaEmbed.warmConnections, {
      once: true,
    });
    this.addEventListener("click", this.addIframe);
  }

  getFeaturePolicy() {
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    let policy = "autoplay *; camera 'none'; microphone 'none';";
    
    if (!isFirefox) {
      policy += " accelerometer *; encrypted-media *; gyroscope *; picture-in-picture *;";
    }
    
    return policy;
  }

  setupPlayButton() {
    let playBtnEl = this.querySelector(".lty-playbtn");
    this.playLabel =
      (playBtnEl && playBtnEl.textContent.trim()) ||
      this.getAttribute("playlabel") ||
      "Play";

    if (!playBtnEl) {
      playBtnEl = document.createElement("button");
      playBtnEl.type = "button";
      playBtnEl.classList.add("lty-playbtn");

      // Create the SVG element
      const svgEl = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg"
      );
      svgEl.setAttribute("id", "videoPlayBtn"); // Add the id attribute
      svgEl.setAttribute("fill", "none");
      svgEl.setAttribute("viewBox", "0 0 96 96");
      svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");

      // Create the circle element
      const circleEl = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "circle"
      );
      circleEl.setAttribute("cx", "48");
      circleEl.setAttribute("cy", "48");
      circleEl.setAttribute("r", "46.8");
      circleEl.setAttribute("stroke", "#fff");
      circleEl.setAttribute("stroke-width", "2");
      circleEl.setAttribute("class", "play-circle");

      // Create the path element
      const pathEl = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      pathEl.setAttribute("d", "m34.1 24.2 40.6 23.4L34 71z");
      pathEl.setAttribute("stroke", "#fff");
      pathEl.setAttribute("stroke-width", "2");
      pathEl.setAttribute("class", "play-triangle");

      // Append the circle and path elements to the SVG
      svgEl.appendChild(circleEl);
      svgEl.appendChild(pathEl);

      // Append the SVG to the button
      playBtnEl.appendChild(svgEl);

      this.appendChild(playBtnEl);
    }

    if (!playBtnEl.textContent) {
      const playBtnLabelEl = document.createElement("span");
      playBtnLabelEl.className = "lyt-visually-hidden";
      playBtnLabelEl.textContent = this.playLabel;
      playBtnEl.appendChild(playBtnLabelEl);
    }
  }
  static warmConnections() {
    if (LiteWistiaEmbed.preconnected) return;
    LiteWistiaEmbed.addPrefetch("preconnect", "https://fast.wistia.net");
    //LiteWistiaEmbed.addPrefetch("preconnect", "https://fast.wistia.com");
    LiteWistiaEmbed.preconnected = true;
  }

  static addPrefetch(kind, url, as) {
    const linkEl = document.createElement("link");
    linkEl.rel = kind;
    linkEl.href = url;
    if (as) {
      linkEl.as = as;
    }
    document.head.append(linkEl);
  }
  async addIframe() {
    if (this.classList.contains("lyt-activated")) return;
    this.classList.add("lyt-activated");

    const shouldAutoplayWithSound =
      this.getAttribute("data-autoplay") === "sound";
    const shouldAutoplayWithPause =
      this.getAttribute("data-autoplay") === "pause";
    const params = {
      videoFoam: "true",
    };

    if (shouldAutoplayWithSound) {
      Object.assign(params, {
        autoPlay: "true",
        controlsVisibleOnLoad: "false",
        endVideoBehavior: "reset",
        fitStrategy: "cover",
        fullscreenButton: "false",
        playbackRateControl: "false",
        playButton: "false",
        playbar: "false",
        playsinline: "true",
        preload: "none",
        qualityControl: "false",
        seo: "false",
        settingsControl: "false",
        silentAutoPlay: "false",
        smallPlayButton: "false",
        volumeControl: "false",
      });
    } else if (shouldAutoplayWithPause) {
      Object.assign(params, {
        autoPlay: "true",
        controlsVisibleOnLoad: "true",
        endVideoBehavior: "reset",
        fitStrategy: "cover",
        fullscreenButton: "false",
        playbackRateControl: "false",
        playbar: "false",
        playPauseNotifier: "true",
        playsinline: "true",
        preload: "none",
        qualityControl: "false",
        seo: "false",
        settingsControl: "false",
        silentAutoPlay: "false",
        smallPlayButton: "false",
        volumeControl: "false",
      });
    } else {
      Object.assign(params, {
        autoPlay: "true",
        controlsVisibleOnLoad: "false",
        endVideoBehavior: "loop",
        fitStrategy: "cover",
        fullscreenButton: "false",
        playbackRateControl: "false",
        muted: "true",
        playButton: "false",
        playbar: "false",
        playsinline: "true",
        preload: "none",
        qualityControl: "false",
        seo: "false",
        settingsControl: "false",
        silentAutoPlay: "true",
        smallPlayButton: "false",
        volume: "0",
        volumeControl: "false",
      });
    }

    const searchParams = new URLSearchParams(params);
    const iframeEl = document.createElement("iframe");
    iframeEl.width = 560;
    iframeEl.height = 315;
    iframeEl.title = this.playLabel;
    iframeEl.allow = this.getFeaturePolicy();
    iframeEl.allowFullscreen = true;
    iframeEl.src = `https://fast.wistia.net/embed/iframe/${encodeURIComponent(
      this.videoId
    )}?${searchParams.toString()}`;
    this.append(iframeEl);
    iframeEl.focus();
  }
  
  
  /*
  async addIframe() {
    if (this.classList.contains("lyt-activated")) return;
    this.classList.add("lyt-activated");

    const shouldAutoplay = this.getAttribute("data-autoplay") === "true";
    const shouldAutoplayWithSound = this.getAttribute("data-autoplay-sound") === "true";
    let params = "";
    if (shouldAutoplay) {
        if (shouldAutoplayWithSound) {
            params =
                "&autoPlay=true&controlsVisibleOnLoad=false&endVideoBehavior=loop&fitStrategy=cover&fullscreenButton=false&playbackRateControl=false&playButton=false&playbar=false&playsinline=true&preload=none&qualityControl=false&seo=false&settingsControl=false&silentAutoPlay=false&smallPlayButton=false&videoFoam=false&volumeControl=true";
        } else {
            params =
                "&autoPlay=muted&controlsVisibleOnLoad=false&endVideoBehavior=loop&fitStrategy=cover&fullscreenButton=false&playbackRateControl=false&muted=true&playButton=false&playbar=false&playsinline=true&preload=none&qualityControl=false&seo=false&settingsControl=false&silentAutoPlay=true&smallPlayButton=false&videoFoam=false&volume=0&volumeControl=false";
        }
    }
    const iframeEl = document.createElement("iframe");
    iframeEl.width = 560;
    iframeEl.height = 315;
    iframeEl.title = this.playLabel;
    iframeEl.allow =
        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
    iframeEl.allowFullscreen = true;
    iframeEl.src = `https://fast.wistia.net/embed/iframe/${encodeURIComponent(
        this.videoId
    )}?videoFoam=true&autoplay=1${params}`;
    this.append(iframeEl);
    iframeEl.focus();
}
*/
}

// Register custom element
customElements.define("lite-wistia", LiteWistiaEmbed);

/**
document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.newsletter-form');
    const emailInput = document.getElementById('newsletter-email');
    const errorDiv = document.getElementById('newsletter-error');
    const formWrapper = document.querySelector('.newsletter-input-wrapper');

    form.onsubmit = function(e) {
        e.preventDefault();

        const email = emailInput.value;
        if (!validateEmail(email)) {
            emailInput.style.borderColor = 'red';
            errorDiv.innerHTML = '<small style="color: red;">Please enter a valid email.</small>';
            return false;
        }

        // Setup AJAX request
        const xhr = new XMLHttpRequest();
        xhr.open('POST', ajax_object.ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                // Assuming the server responds with a success message
                formWrapper.innerHTML = '<p>Thank You for Subscribing</p>';
                // Track the successful subscription with GA
                if (window.ga) {
                    ga('send', 'event', 'Newsletter', 'subscribe', 'Footer Newsletter');
                }
            } else {
                emailInput.style.borderColor = 'red';
                errorDiv.innerHTML = '<small style="color: red;">Please enter a valid email.</small>';
            }
        };
        xhr.onerror = function() {
            // Handle network errors
            emailInput.style.borderColor = 'red';
            errorDiv.innerHTML = '<small style="color: red;">Network Error. Please try again later.</small>';
        };

        // Send the AJAX request
        xhr.send('action=submit_newsletter&newsletter_email=' + encodeURIComponent(email));
    };

    function validateEmail(email) {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(email);
    }
});
* */
function updateInlineVideoWrapperWidth() {
  const mediaCell = document.querySelector(
    'lite-wistia.lite-wistia-24x36[data-autoplay="true"]'
  );

  if (mediaCell) {
    const inlineVideoWrapper = mediaCell.querySelector("iframe");
    const mediaCellHeight = mediaCell.offsetHeight;
    const inlineVideoWrapperWidth = mediaCellHeight * (24 / 36);
    inlineVideoWrapper.style.width = `${inlineVideoWrapperWidth}px`;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const specificItem = document.querySelector(
    'lite-wistia.lite-wistia-24x36[data-autoplay="true"]'
  );

  if (specificItem) {
    updateInlineVideoWrapperWidth();
    window.addEventListener("resize", updateInlineVideoWrapperWidth);
  }
});

class AutoplayInlineWistia extends HTMLElement {
  connectedCallback() {
    this.videoId = this.getAttribute("videoid");
    this.addIframe();
    this.addEventListener("pointerover", AutoplayInlineWistia.warmConnections, {
      once: true,
    });
  }

  static warmConnections() {
    if (AutoplayInlineWistia.preconnected) return;
    AutoplayInlineWistia.addPrefetch("preconnect", "https://fast.wistia.net");
    AutoplayInlineWistia.addPrefetch("preconnect", "https://fast.wistia.com");
    AutoplayInlineWistia.preconnected = true;
  }

  static addPrefetch(kind, url) {
    const linkEl = document.createElement("link");
    linkEl.rel = kind;
    linkEl.href = url;
    document.head.append(linkEl);
  }

  addIframe() {
    if (this.classList.contains("lyt-activated")) return;
    this.classList.add("lyt-activated");

    const params =
      "&autoPlay=muted&controlsVisibleOnLoad=false&endVideoBehavior=loop&fitStrategy=cover&fullscreenButton=false&playbackRateControl=false&muted=true&playButton=false&playbar=false&playsinline=true&preload=none&qualityControl=false&seo=false&settingsControl=false&silentAutoPlay=true&smallPlayButton=false&videoFoam=false&volume=0&volumeControl=false";
    const iframeEl = document.createElement("iframe");
    iframeEl.width = 560;
    iframeEl.height = 315;
    iframeEl.title = "Wistia Video"; // Provide a generic title or use an attribute to set a specific title
    iframeEl.allow =
      "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
    iframeEl.allowFullscreen = true;
    iframeEl.src = `https://fast.wistia.net/embed/iframe/${encodeURIComponent(
      this.videoId
    )}?videoFoam=true&autoplay=1${params}`;
    this.append(iframeEl);
    iframeEl.focus();
  }
}

// Register the custom element
customElements.define("autoplay-inline-wistia", AutoplayInlineWistia);

document.addEventListener("DOMContentLoaded", function () {
  const scrollAnchors = document.querySelectorAll(".scroll-anchor");
  const headerHeight = 400; // Adjust this value to match your sticky header height

  scrollAnchors.forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      const targetPosition = target.getBoundingClientRect().top;
      const offsetPosition = targetPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    });
  });
});

// Get the menu and search container elements
var menuContainer = document.querySelector(".riester-main-menu-container");
var searchContainer = document.querySelector(".riester-search-container");

// Function to enable/disable transitions
function toggleTransitions(enable) {
  if (enable) {
    menuContainer.style.transition = "transform 0.4s ease-in-out";
    searchContainer.style.transition = "transform 0.4s ease-in-out";
  } else {
    menuContainer.style.transition = "none";
    searchContainer.style.transition = "none";
  }
}

// Disable transitions on window resize
window.addEventListener("resize", function () {
  toggleTransitions(false);
});

// Re-enable transitions after window resize
window.addEventListener("resizeend", function () {
  toggleTransitions(true);
});

// Custom event for detecting the end of window resize
(function () {
  var timeout;
  window.addEventListener("resize", function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      var event = new CustomEvent("resizeend");
      window.dispatchEvent(event);
    }, 100);
  });
})();

/**
 * Implements a custom cursor that follows the mouse movement and hides when hovering over video elements.
 * The cursor is hidden when the window width is less than or equal to 769 pixels.
 */
gsap.set(".cs-cursor", { xPercent: -50, yPercent: -50 });

let cursorX = 0;
let cursorY = 0;

window.addEventListener("mousemove", (e) => {
  cursorX = e.x;
  cursorY = e.y;
});

gsap.ticker.add(() => {
  gsap.to(".cs-cursor", {
    duration: 0.05,
    ease: "power2.out",
    x: cursorX,
    y: cursorY + window.pageYOffset,
  });
});

// Hide the custom cursor when the play button is clicked and show it when the mouse leaves the Wistia frame
document.querySelectorAll('lite-wistia[data-autoplay="pause"]').forEach((wistiaFrame) => {
  const playButton = wistiaFrame.querySelector(".lty-playbtn");

  if (playButton) {
    playButton.addEventListener("click", () => {
      setTimeout(() => {
        if (wistiaFrame.classList.contains("lyt-activated")) {
          gsap.to(".cs-cursor", { opacity: 0, duration: 0.1 });

          const iframe = wistiaFrame.querySelector("iframe");
          if (iframe) {
            iframe.style.pointerEvents = "auto!important";
            iframe.style.zIndex = "1";
          }

          wistiaFrame.addEventListener("mouseenter", () => {
            gsap.to(".cs-cursor", { opacity: 0, duration: 0.1 });
          });

          wistiaFrame.addEventListener("mouseleave", () => {
            gsap.to(".cs-cursor", { opacity: 1, duration: 0.1 });
          });
        }
      }, 0);
    });
  }
});




// Add or remove hidden class based on window width
function updateCursorVisibility() {
  if (window.innerWidth <= 769) {
    document.querySelector(".cs-cursor").classList.add("hidden");
  } else {
    document.querySelector(".cs-cursor").classList.remove("hidden");
  }
}

// Initial check
updateCursorVisibility();

// Update on resize
window.addEventListener("resize", updateCursorVisibility);

